module.exports = __webpack_public_path__ + "static/img/down_img06.png.462f711.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sptj/down_img06.png.png
// module id = tKEi
// module chunks = 1